import { Box, Grid } from "@mui/material";
import React, { Component } from "react";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import JobInItemEntry from "./JobInItemEntry";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";

class JobInEntry extends Component {
  state = {
    CompanyName: [],
    Customer: [],
    DriverName: [],
    ItemName: [],
    Packing: [],
    TaxName: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "itemsrno", label: "Item Sr. No." },
      { id: "itemname", label: "Item Name" },
      { id: "packing", label: "Packing" },
      { id: "quantity", label: "Quantity" },
      { id: "rate", label: "Rate" },
      { id: "basicamt", label: "Basic Amt" },
      { id: "dis", label: "Dis (%)" },
      { id: "disamt", label: "Dis Amt" },
      { id: "taxable", label: "Taxable" },
      { id: "taxname", label: "Tax Name" },
      { id: "cgst", label: "CGST" },
      { id: "sgst", label: "SGST" },
      { id: "igst", label: "IGST" },
      { id: "totalamount", label: "Total Amount" },
      // { id: "remark", label: "Remark" },
    ],
    searchData: {
      itemsrno: "",
      itemname: "",

      packing: "",
      quantity: "",

      rate: "",
      basicamt: "",
      dis: "",
      disamt: "",
      taxable: "",
      taxname: "",
      cgst: "",
      sgst: "",
      igst: "",
      totalamount: "",
      // remark: "",
    },
    rows: [],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Job In Entry";
    this.props.setActiveMenu("JobInEntry");
    this.setSearchColumns();
  }
  //#endregion Component

  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.itemsrno.length === 0 ||
            (row["itemsrno"] &&
              row["itemsrno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.itemsrno.toLowerCase()))) &&
          (this.state.searchData.itemname.length === 0 ||
            (row["itemname"] &&
              row["itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.itemname.toLowerCase()))) &&
          (this.state.searchData.packing.length === 0 ||
            (row["packing"] &&
              row["packing"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.packing.toLowerCase()))) &&
          (this.state.searchData.quantity.length === 0 ||
            (row["quantity"] &&
              row["quantity"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.quantity.toLowerCase()))) &&
          (this.state.searchData.rate.length === 0 ||
            (row["rate"] &&
              row["rate"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.rate.toLowerCase()))) &&
          (this.state.searchData.basicamt.length === 0 ||
            (row["basicamt"] &&
              row["basicamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.basicamt.toLowerCase()))) &&
          (this.state.searchData.dis.length === 0 ||
            (row["dis"] &&
              row["dis"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dis.toLowerCase()))) &&
          (this.state.searchData.disamt.length === 0 ||
            (row["disamt"] &&
              row["disamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.disamt.toLowerCase()))) &&
          (this.state.searchData.taxable.length === 0 ||
            (row["taxable"] &&
              row["taxable"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.taxable.toLowerCase()))) &&
          (this.state.searchData.taxname.length === 0 ||
            (row["taxname"] &&
              row["taxname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.taxname.toLowerCase()))) &&
          (this.state.searchData.cgst.length === 0 ||
            (row["cgst"] &&
              row["cgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.cgst.toLowerCase()))) &&
          (this.state.searchData.sgst.length === 0 ||
            (row["sgst"] &&
              row["sgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.sgst.toLowerCase()))) &&
          (this.state.searchData.igst.length === 0 ||
            (row["igst"] &&
              row["igst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.igst.toLowerCase()))) &&
          (this.state.searchData.totalamount.length === 0 ||
            (row["totalamount"] &&
              row["totalamount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.totalamount.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };
  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };
  //#endregion Handle

  //#region function
  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };
  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<JobInItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "itemsrno",
        label: "Item Sr. No.",
        value: this.state.searchData.itemsrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "itemname",
        items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "packing",
        items: this.state.Packing,
        label: "Packing",
        value: this.state.searchData.packing,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "quantity",
        label: "Quantity",
        value: this.state.searchData.quantity,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "rate",
        label: "Rate",
        value: this.state.searchData.rate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "basicamt",
        label: "Basic Amt",
        value: this.state.searchData.basicamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "dis",
        label: "Dis",
        value: this.state.searchData.dis,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "disamt",
        label: "Dis Amt",
        value: this.state.searchData.disamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "taxable",
        label: "Taxable",
        value: this.state.searchData.taxable,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "taxname",
        items: this.state.TaxName,
        label: "Tax Name",
        value: this.state.searchData.taxname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "cgst",
        label: "CGST",
        value: this.state.searchData.cgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "sgst",
        label: "SGST",
        value: this.state.searchData.sgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "igst",
        label: "IGST",
        value: this.state.searchData.igst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "totalamount",
        label: "Total Amount",
        value: this.state.searchData.totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      }
      // {
      //   cType: "CtTxt",
      //   id: "remark",
      //   label: "Remark",
      //   value: this.state.searchData.remark,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // }
    );
    this.setState({ searchColumns });
  };

  //#endregion function
  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Job In Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbCompanyName"
                  label="Company Name"
                  onKeyDown={this.props.onKeyDown}
                  items={this.state.CompanyName}
                  width={200}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtLoadingSrNo."
                  label="Job In Sr. No."
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtDtp id="dtpDate" label="Job In Date" width="170" />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbCustomer"
                  label="Customer"
                  onKeyDown={this.props.onKeyDown}
                  items={this.state.Customer}
                  width={200}
                  maxLength={100}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt id="txtDisAmt" label="Dis Amt" maxLength={10} />
              </Grid>
              <Grid item>
                <CtTxt id="txtTaxable" label="Taxable" maxLength={10} />
              </Grid>
              <Grid item>
                <CtTxt id="txtCGST" label="CGST" maxLength={10} />
              </Grid>
              <Grid item>
                <CtTxt id="txtSGST" label="SGST" maxLength={10} />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt id="txtIGST" label="IGST" maxLength={10} />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtTotalAmount"
                  label="Total Amount"
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  maxLength={1500}
                  width="330"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems={"center"}
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtBtn label="Save" />
              </Grid>
              <Grid item>
                <CtBtn label="New" />
              </Grid>
              <Grid item>
                <CtBtn label="Delete" />
              </Grid>
              <Grid item>
                <CtBtn label="Close" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          headRowFontColor="#ffffff"
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Order Item Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(withRouter(JobInEntry));
